import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/observability/sentry";
import { redirectLegacyDomainToPrimary } from "./lib/primaryDomain";
import { registerAppServiceWorker } from "./lib/pwa/registerSW";
import { initAnalytics } from "./lib/analytics";

if (!redirectLegacyDomainToPrimary()) {
  initSentry();
  initAnalytics();
  registerAppServiceWorker();

  createRoot(document.getElementById("root")!).render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
}
